import type { TFlightFormValues } from "@/app/lib/types/types";
import dayjs from "dayjs";
import { useFormikContext } from "formik";
import { useEffect } from "react";

export const DatesGuard = () => {
  const { values, setFieldValue } = useFormikContext<TFlightFormValues>();
  const { departure: departureDate, return: returnDate } = values.dates;

  useEffect(() => {
    if (
      returnDate &&
      departureDate &&
      dayjs(returnDate).isBefore(dayjs(departureDate))
    ) {
      setFieldValue("dates.return", departureDate);
    }
  }, [departureDate, returnDate, setFieldValue]);

  return null;
};
